module.exports = __webpack_public_path__ + "static/media/bgsidebar.1d3f53af.jpg";